import Icon from '../components/Icon.vue'

Icon.register({
  'greater-than': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M365.5 209.8c11.3 5.3 18.5 16.6 18.5 29v34.2c0 11.3-8.3 24.2-18.5 29l-306.5 142.9c-16 7.5-35.1 0.5-42.5-15.5l-13.5-29c-7.5-16-0.5-35.1 15.5-42.5l218.5-101.9-218.4-101.8c-16.1-7.5-23-26.6-15.5-42.6l13.6-29.1c7.5-16.1 26.6-23 42.6-15.5z'
      }
    ]
  }
})
